<script>
  export let color = "";
  export let imgUrl = "";
  // export let showPoweredBy = '';
  export let sbGreeting = null;
  export let sbSlogan = null;
  export let recentText = null;
  export let similarText = null;

  let recentProducts = [
    {
      name: "Syltherine",
      price: "160",
      image: "/img/preview-product-1.png",
    },
    {
      name: "Lolito",
      price: "240",
      image: "/img/preview-product-2.png",
    },
    {
      name: "Black chair",
      price: "240",
      image: "/img/preview-product-3.png",
    },
  ];
  let similarProducts = [
    {
      name: "Blue armchair",
      price: "360",
      image: "/img/preview-product-4.png",
    },
    {
      name: "Lolito",
      price: "240",
      image: "/img/preview-product-2.png",
    },
    {
      name: "Wooden chair",
      price: "240",
      image: "/img/preview-product-1.png",
    },
  ];
</script>

<section class="preview-wrapper">
  <div class="preview-header" style="--bg-preview-color:{color};">
    <img class="preview-logo" src={imgUrl} alt="" />

    <p class="preview-greeting">{sbGreeting ? sbGreeting : "Hi"}</p>
    <p class="sb-slogan">{sbSlogan ? sbSlogan : "I am your personal shopping assistant"}</p>
  </div>
  <div class="preview-body">
    <div class="preview-product-grid">
      <p class="sb-heading">{recentText ? recentText : "Recently Viewed Items"}</p>
      <ul>
        {#each recentProducts as product}
          <li>
            <img src={product.image} alt="Example product." />
            <p class="example-product-name">{product.name}</p>
            <span class="example-product-price">€{product.price}</span>
          </li>
        {/each}
      </ul>
      <div class="preview-button">
        <p>See more products</p>
      </div>
    </div>
    <div class="preview-product-grid">
      <p class="sb-heading">{similarText ? similarText : "Similar Products"}</p>
      <ul>
        {#each similarProducts as product}
          <li>
            <img src={product.image} alt="Example product." />
            <p class="example-product-name">{product.name}</p>
            <span class="example-product-price">€{product.price}</span>
          </li>
        {/each}
      </ul>
    </div>
  </div>
  <div class="preview-footer">
    <!-- <p class={showPoweredBy}>Powered by Shopbox</p> -->
    <p>Powered by Shopbox</p>
  </div>
</section>

<style>
  .preview-wrapper {
    width: 260px;
    height: 420px;
    position: absolute;
    top: 0;
    left: 100%;
    margin: 0 0 0 1em;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 8px 12px rgba(232, 159, 113, 0.2), 0px 2px 8px rgba(0, 0, 0, 0.2);
  }
  .preview-header,
  .preview-body,
  .preview-footer {
    padding: 0.5em 0.5em 0;
  }
  .preview-header {
    height: 80px;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
  }
  .preview-header::after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: var(--bg-preview-color);
    opacity: 0.3;
  }
  .preview-logo {
    height: 24px;
    display: block;
    object-fit: contain;
    object-position: left;
    top: 8px;
    left: 12px;
    margin-bottom: 0.6em;
  }
  .preview-greeting {
    color: #000;
    white-space: nowrap;
  }
  .preview-greeting,
  .sb-slogan {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .sb-slogan,
  .preview-product-grid > p,
  .example-product-name,
  .example-product-price {
    font-size: 0.75rem;
    font-weight: 100;
    color: var(--t-c-l);
  }
  .example-product-name {
    color: var(--t-c);
  }
  .preview-body {
    height: 70%;
  }
  .preview-product-grid {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    height: auto;
    margin-bottom: 0.5em;
  }
  ul {
    list-style: none;
    padding: 0;
    display: flex;
    justify-content: space-around;
  }
  li > img {
    border-radius: 4px;
  }
  .preview-product-grid > p {
    margin: 0.5em;
    color: var(--t-c);
  }
  .preview-button {
    border-top: 1px solid #e0e0e0;
    padding: 0.3em 0;
  }
  .preview-button p {
    font-size: 0.75rem;
    color: var(--t-c);
  }
  .preview-footer,
  .preview-button {
    background: #f2f2f2;
    text-align: center;
  }
  .preview-footer {
    padding-top: 0.2em;
    height: 16px;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .preview-footer p {
    font-size: 0.6rem;
    font-weight: 100;
    text-decoration: underline;
    color: var(--t-c-l);
  }
  /* .preview-footer p.true {
    display: none;
  } */
  @media (max-width: 1200px) {
    .preview-wrapper {
      display: none;
    }
  }
</style>
